module.exports = __webpack_public_path__ + "static/media/logo-external.dc3e556e.png";